import { StaticQuery, graphql } from 'gatsby'
import React from 'react'
import { inlineLexer } from 'marked'
import { injectIntl } from 'react-intl'
import { findLocalized } from '../utils'

const Arrivare = ({ intl: { locale } }) => (
  <StaticQuery
    query={graphql`
      query {
        allArrivareYaml{
          edges{
            node{
              title
              info
              means{
                title
                subtitle
                info
                info2
              }
              lang
            }
          }
        }   
      }
    `}
    render={data => {
      const { title, info, means } = findLocalized(data.allArrivareYaml, locale);
      const [pubblici, aereo, auto, treno] = means;
      return (
        <section id="arrivare" className="section arrivare" aria-labelledby="region2">
          <div className="container">
            <div className="row" data-aos="fade-up">
              <div className="col-sm-10 col-sm-offset-1 col-md-8 col-md-offset-2">
                <h1 id="region2" className="section__title text-center">{title}</h1>
                <div className="row">
                  <div className="col-sm-12">
                    <div dangerouslySetInnerHTML={{__html: inlineLexer(info, [])}}></div>
                    <br />
                    <div className="ratio-1by1">
                      <iframe title={title} width="100%" height="350" frameBorder="0" style={{ border: '0' }} allowFullScreen
                        src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d2798.208434226542!2d9.171951!3d45.465605!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x46acd9caac75e94a!2sHotel+Palazzo+delle+Stelline!5e0!3m2!1sit!2sit!4v1550153332877">...</iframe>
                    </div>
                    <br />
                  </div>
                </div>
                <div className="row">
                  <div className="col-sm-12">
                    <div className="arrivare__text">
                      <h2 className="arrivare__title">{pubblici.title}</h2>
                      <p dangerouslySetInnerHTML={{__html: inlineLexer(pubblici.subtitle, [])}}></p>
                      <p dangerouslySetInnerHTML={{__html: inlineLexer(pubblici.info, [])}}></p>
                      <br />

                      <h2 className="arrivare__title">{aereo.title}</h2>
                      <div dangerouslySetInnerHTML={{__html: inlineLexer(aereo.info, [])}}></div>
                      <br />
                      <div dangerouslySetInnerHTML={{__html: inlineLexer(aereo.info2, [])}}></div>
                      <br />

                      <h2 className="arrivare__title">{auto.title}</h2>
                      <p dangerouslySetInnerHTML={{__html: inlineLexer(auto.info, [])}}></p>
                      <p dangerouslySetInnerHTML={{__html: inlineLexer(auto.info2, [])}}></p>
                      <br />

                      <h2 className="arrivare__title">{treno.title}</h2>
                      <p dangerouslySetInnerHTML={{__html: inlineLexer(treno.info, [])}}></p>

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      );
    }} 
  />
);

export default injectIntl(Arrivare);
